import _ from 'lodash';
import { useEffect } from 'react';
import { showMessage } from '~/helper';
import api from '~/services/api';
import useGlobalContext from '~/view-data/use-global-context';
import useFetch from '~/view-data/use-fetch';
import useHeader from '~/view-data/use-header';

const initialState = {
  loading: false,
  formLoading: false,
  term: null,
  offset: 0,
  model: null,
  data: { rows: [], count: 0, offset: 0 },
};

const useEventTypes = () => {
  const { state: { eventTypes = initialState }, dispatch } = useGlobalContext(),
    { actions: headerActions } = useHeader();

  const { data, mutate } = useFetch({
    url: 'event-types/list',
    params: { term: eventTypes.term, offset: eventTypes.offset },
  });

  useEffect(() => {
    headerActions.configure({
      title: 'Tipos de evento',
      count: _.get(data, 'count', 0),
      loading: _.get(eventTypes, 'loading', false),
      onSearch: (text) => list(0, text),
    });
    // eslint-disable-next-line
  }, [data, eventTypes]);

  const list = (offset = 0, term) => {
    dispatch({ type: 'eventTypes', payload: { offset, term } });
  };

  const pageChange = (offset = 0) => {
    dispatch({ type: 'eventTypes', payload: { offset } });
  };

  const load = async (data = {}) => {
    try {
      dispatch({
        type: 'eventTypes',
        payload: { model: {}, formLoading: true },
      });
      let model = { active: true };

      if (data.id) {
        const response = await api.get('event-types/load', { params: { id: data.id } });
        model = response.data;
      }
      dispatch({ type: 'eventTypes', payload: { model, formLoading: false } });
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const createOrUpdate = async (model, actions) => {
    try {
      dispatch({ type: 'eventTypes', payload: { formLoading: true } });

      let editing = !!(model && model.id),
        method = editing ? 'put' : 'post',
        path = editing ? 'update' : 'create';

      await api[method](`event-types/${path}`, model);

      mutate(data);

      showMessage('success', `Tipo de evento ${editing ? 'atualizado' : 'criado'} com sucesso`);

      actions.toogleForm && actions.toogleForm();
    } catch (error) {
      failure(error, dispatch);
    }
  };

  return {
    state: {
      ...eventTypes,
      data: data || {},
      loading: !data,
    },
    actions: {
      pageChange,
      load,
      list,
      createOrUpdate,
    },
  };
};

const failure = (error, dispatch) => {
  dispatch({ type: 'eventTypes', payload: { loading: false, formLoading: false }});
  showMessage('error', error);
};

export default useEventTypes;
